import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrCheckListExpenseGet, SrChecklistService } from '@app/services/sr-checklist.service';
import { SrRefundService } from '@app/services/sr-refund.service';

@Component({
    selector: 'tt-sr-check-list-expense',
    templateUrl: './sr-check-list-expense.component.html',
    styleUrls: ['./sr-check-list-expense.component.css'],
    standalone: false,
})
export class SrCheckListExpenseComponent implements OnInit {
    public page?: SrCheckListExpenseGet;
    public inputs: Item[] = [];
    public saving = false;
    public calculating = false;

    constructor(
        private readonly checklist: SrChecklistService,
        private readonly refund: SrRefundService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        const params = {
            checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? ''),
            srrefundinput_keyno: String(this.navigator?.params['srrefundinput_keyno'] ?? '0'),
        };
        const [page, inputs] = await Promise.all([this.checklist.getExpense(params), this.refund.getInputs({ srrefundinput_keyno: params.srrefundinput_keyno })]);
        this.page = page;
        this.inputs = inputs;
    }

    public async calculateAmount(): Promise<void> {
        if (!this.page || this.calculating) return;
        this.calculating = true;
        try {
            const value: unknown = await this.modal.showCalculator('expense_amount', undefined, this.page.expense_amount);
            if (typeof value === 'string' || typeof value === 'number') this.page.expense_amount = value;
        } finally { this.calculating = false; }
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try {
            const response = await this.checklist.saveExpense(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
